import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const brandSlice = createSlice({
  name: "brand",
  initialState: {
    brandData: [],
    isError: false,
  },

  reducers: {
    fetchBrandSuccess: (state, action) => {
      state.isError = false;
      state.brandData = action.payload;
    },
    fetchBrandFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchBrandSuccess, fetchBrandFailure } = brandSlice.actions;

export const fetchBrand = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchBrandSuccess(response.data.brand_list));
  } catch (error) {
    dispatch(fetchBrandFailure());
  }
};

export default brandSlice.reducer;
